import * as Dropdown from './Dropdown'
import * as FileUploader from './FileUploader'
import * as Input from './Input'
import * as MultiSelectCombobox from './MultiSelectCombobox'
import * as RadioCard from './RadioCard'
import * as Utils from './yup/utils'

export const L3OnboardingFields = {
  Dropdown,
  FileUploader,
  Input,
  MultiSelectCombobox,
  RadioCard,
  Utils,
}
